import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../services/admin/admin.service';

const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {
  analytics: any = null;
  planBreakdownList: any[] = [];
  malePercent = 0;
  femalePercent = 0;

  constructor(private adminService: AdminService) {}

  ngOnInit(): void {
    this.adminService.getAnalytics().subscribe({
      next: (res) => {
        if (res.status === 'success') {
          this.analytics = res.data;
          this.buildPlanBreakdown();
          this.buildSignupTrend(this.analytics.signup_trend);
          const total = this.analytics.users.total || 1;
          this.malePercent = Math.round((this.analytics.users.male / total) * 100);
          this.femalePercent = Math.round((this.analytics.users.female / total) * 100);
        }
      },
      error: (err) => console.error('[Admin Dashboard]', err)
    });
  }

  buildPlanBreakdown(): void {
    const pb = this.analytics.users.plan_breakdown;
    const total = this.analytics.users.total || 1;
    this.planBreakdownList = [
      { code: 'FREE', count: pb.free, percent: Math.round((pb.free / total) * 100) },
      { code: 'SILVER', count: pb.silver, percent: Math.round((pb.silver / total) * 100) },
      { code: 'GOLD', count: pb.gold, percent: Math.round((pb.gold / total) * 100) },
      { code: 'PLATINUM', count: pb.platinum, percent: Math.round((pb.platinum / total) * 100) },
    ];
  }

  buildSignupTrend(rawTrend: any[]): void {
    const trendMap = new Map<string, number>();
    (rawTrend || []).forEach(item => {
      const key = `${item._id.year}-${item._id.month}`;
      trendMap.set(key, item.count);
    });

    const fullTrend = [];
    const now = new Date();
    for (let i = 5; i >= 0; i--) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const year = d.getFullYear();
      const month = d.getMonth() + 1;
      const key = `${year}-${month}`;
      const count = trendMap.get(key) || 0;
      fullTrend.push({
        _id: { year, month },
        count
      });
    }
    this.analytics.signup_trend = fullTrend;
  }

  getMonthLabel(monthNum: number): string {
    return MONTH_NAMES[(monthNum - 1) % 12];
  }

  getTrendHeight(count: number): number {
    if (!count || count <= 0) return 6;
    const counts = (this.analytics.signup_trend || []).map((m: any) => m.count);
    const max = Math.max(...counts, 1);
    return Math.max(Math.round((count / max) * 140), 12);
  }

  getPlanRevenue(planCode: string): number {
    if (!this.analytics?.revenue?.by_plan) return 0;
    const found = this.analytics.revenue.by_plan.find((p: any) => (p.plan || '').toUpperCase() === (planCode || '').toUpperCase());
    return found ? found.amount : 0;
  }
}
